
export class SaveButton{

    parentSelector

    constructor(parentSelector=null){
        this.buttonDotsInterval;
        this.i = 0;
        this.parentSelector = parentSelector;
        this.button = document.querySelector(`${parentSelector ?? ''} button[data-save]`);
    }

    /**
     * Отображает процесс выполнения операции
     *
     * @returns Promise
     */
    startLoading(message='Saving') {
        return new Promise( () => {
            this.buttonDotsInterval = setInterval(() => {
                $(`${this.parentSelector ?? ''} .component-data-save .error-message`).addClass('d-none').removeClass('text-denger');
                try {
                    this.button.setAttribute('disabled', '');
                    this.button.innerHTML = message + Array((++this.i % 4) + 1).join('.');
                } catch (error) {
                    console.log(error);
                }
            }, 500)
        });
    }

    /**
     *  Останавливает процесс отображение процесса загрузки.
     *
     * @param {boolean} disabled флаг блокирования кнопки: для всплывающих окон true, для всего остального false
     * @returns Promise
     */
    stopLoading(disabled=false,btnText='Save') {
        return new Promise((resolve) => {
            setTimeout(() => {
                clearInterval(this.buttonDotsInterval);
                try {
                    if (!disabled) {
                        this.button.removeAttribute('disabled');
                    }
                    this.button.innerHTML = btnText;
                } catch (error) {
                    console.log(error);
                }

                resolve();
            }, 1200)
        });
    }

    /**
     * Отображает сообщение об успешной операции.
     *
     * @returns Promise
     */
    showSuccess() {
        return new Promise((resolve) => {
            setTimeout(() => {
                try {
                    $(`${this.parentSelector ?? ''} .component-data-save .text-success`).removeClass('d-none')
                } catch (error) {}
                setTimeout(() => {
                    try {
                        $(`${this.parentSelector ?? ''} .component-data-save .text-success`).addClass('d-none');
                    } catch (error) {}
                    resolve();
                }, 1000)
            }, 500)
        });
    }

    /**
     * Отображает сообщение об ошибке при выполнении операции
     *
     * @returns Promise
     */
    showError(message=null) {
        return new Promise( (resolve) => {
            setTimeout(() => {
                try {
                    document.querySelector(`${this.parentSelector ?? ''} .component-data-save .text-danger`).classList.toggle('d-none');
                } catch (error) {}
                setTimeout(() => {
                    try {
                        document.querySelector(`${this.parentSelector ?? ''} .component-data-save .error-message`).classList.remove('d-none');
                        document.querySelector(`${this.parentSelector ?? ''} .component-data-save .text-danger`).classList.toggle('d-none');
                        if(message)
                            document.querySelector(`${this.parentSelector ?? ''} .component-data-save .error-message`).textContent = message
                    } catch (error) {console.log(error)}
                    resolve();
                }, 1500)
            }, 500)
        });
    }
}
